import { useGame } from "../../../data/gameContext";

export default function TelegraphOffice() {
    const {updateGameState} = useGame();
    return (
        <div className="town-container">
            The Telegraph Office
            <button onClick={() => updateGameState({Phase: 'townView'})}>Leave</button>
        </div>
    )
}